// src/api/userQueryApi.js
import { apiClient, getAuthHeader } from "./apiConfig";

// GET all user queries (optional params for future use)
export const fetchUserQueries = async (params = {}) => {
  const res = await apiClient.get("/user-queries", {
    ...getAuthHeader(),
    params,
  });
  return res.data?.data || [];
};

// DELETE a query by id
export const deleteUserQuery = async (id) => {
  return apiClient.delete(`/user-queries/${id}`, getAuthHeader());
};

// (Optional) create/update if you ever need them later
export const createUserQuery = async (payload) => {
  return apiClient.post("/user-queries", payload, getAuthHeader());
};
